export default __webpack_public_path__ + "static/media/icon-close.c5088000.svg";